import { render, staticRenderFns } from "./teamPeople.vue?vue&type=template&id=1bcf70f2&scoped=true&"
import script from "./teamPeople.vue?vue&type=script&lang=js&"
export * from "./teamPeople.vue?vue&type=script&lang=js&"
import style0 from "./teamPeople.vue?vue&type=style&index=0&id=1bcf70f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcf70f2",
  null
  
)

export default component.exports